import apiBaseUrl from '../../utils/config.js';

class ProcedureDiagnosisService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/procedures`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async #request(endpoint, method = 'GET', body = null) {
    const url = `${this.baseUrl}${endpoint}`;
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Request failed: ${response.status}`);
      }
      return response.headers.get('Content-Type')?.includes('application/json')
        ? await response.json()
        : await response.text();
    } catch (error) {
      console.error(`Error during ${method} ${url}:`, error);
      throw error;
    }
  }

  async getAllProcedures() {
    return this.#request('/getAll');
  }

  async searchProcedures({ code, description, differenceCode }) {
    const params = new URLSearchParams();
    if (code) params.append('code', code);
    if (description) params.append('description', description);
    if (differenceCode) params.append('differenceCode', differenceCode);

    return this.#request(`/search?${params.toString()}`);
  }

  async getProcedureById(id) {
    return this.#request(`/${id}`);
  }

  async addProcedure(procedure) {
    return this.#request('/add', 'POST', procedure);
  }

  async updateProcedure(id, updatedProcedure) {
    return this.#request(`/update/${id}`, 'PUT', updatedProcedure);
  }

  async deleteProcedure(id) {
    return this.#request(`/delete/${id}`, 'DELETE');
  }
}

export default ProcedureDiagnosisService;
